import { render } from "./kemasPengecualian.vue?vue&type=template&id=08ce78b6"
import script from "./kemasPengecualian.vue?vue&type=script&lang=js"
export * from "./kemasPengecualian.vue?vue&type=script&lang=js"

import "./kemasPengecualian.vue?vue&type=style&index=0&id=08ce78b6&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__